import { toanQuyen } from '../../hooks/usePermission';
import { useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';

import { duocVaoDichVu } from '../../lib/dich-vu-cong';
import { moduleForPath } from '../../lib/route-permissions';
import { useAuthStore } from '../../stores/auth';
import { ForbiddenView } from '../ForbiddenView';

/**
 * Cổng quyền bọc toàn bộ nội dung nhóm `(main)` (§4.5).
 *
 * Thứ tự xét: chưa có người dùng → vẽ children (cổng đăng nhập tự chuyển
 * hướng); vai trò `SUPER_ADMIN` → vẽ children; nhánh thuộc dịch vụ ngoài gói
 * của người này → `ForbiddenView` (ADR-0034); giải đường dẫn thành mã phân hệ;
 * không có mã nào khớp → vẽ children; người dùng **không** có quyền nào bắt đầu
 * bằng `<MODULE>.` → vẽ `ForbiddenView`.
 */
export function PermissionGuard({ children }: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user);
  const { pathname } = useLocation();

  if (!user) return <>{children}</>;
  if (toanQuyen(user)) return <>{children}</>;

  // Xét dịch vụ trước phân hệ: một phân hệ có thể nằm ở hai dịch vụ
  // (`ROLE_CONFIG` ở cả Cấu hình hệ thống lẫn Báo cáo doanh nghiệp), nên có
  // quyền phân hệ chưa chắc nhánh này thuộc gói. Nhánh không có mã phân hệ
  // (`/rpa/*`) cũng bị chặn ở đây khi tenant không thuê RPA.
  if (!duocVaoDichVu(pathname, user.dichVu)) return <ForbiddenView />;

  const moduleCode = moduleForPath(pathname);
  if (!moduleCode) return <>{children}</>;

  const allowed = user.permissions.some((p) => p.startsWith(`${moduleCode}.`));
  return allowed ? <>{children}</> : <ForbiddenView />;
}
